import React, { useRef, useState } from "react";

const ImageGridV2 = ({ images, activeImageGroup }) => {

  const group = images[activeImageGroup];

  const sliderRef = useRef(null);

  const isDown = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);
  const [activeDot, setActiveDot] = useState(0);
  if (!activeImageGroup) return null;

  return (

    <div className="w-full flex flex-col items-center mt-12 px-4">

      <div
  style={{
    width: "100%",
    maxWidth: "1200px",
    overflow: "hidden",
    margin: "0 auto"
  }}
>

        <div

          ref={sliderRef}

          onMouseDown={(e) => {

            isDown.current = true;

            startX.current = e.pageX;

            scrollLeft.current = sliderRef.current.scrollLeft;

            sliderRef.current.style.cursor = "grabbing";

          }}

          onMouseLeave={() => {

            isDown.current = false;

            if (sliderRef.current) {
              sliderRef.current.style.cursor = "grab";
            }

          }}

          onMouseUp={() => {

            isDown.current = false;

            if (sliderRef.current) {
              sliderRef.current.style.cursor = "grab";
            }

          }}

          onMouseMove={(e) => {

            if (!isDown.current) return;

            e.preventDefault();

            const x = e.pageX;

            const walk = (x - startX.current) * 1.5;

            sliderRef.current.scrollLeft = scrollLeft.current - walk;

          }}

          style={{
            display: "flex",
            gap: "24px",
            overflowX: "auto",
            scrollSnapType: "x mandatory",
            scrollBehavior: "smooth",
            paddingBottom: "15px",
            paddingLeft: "3%",
            paddingRight: "3%",
            cursor: "grab",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            userSelect: "none"
          }}

          className="hide-scrollbar"
          onScroll={() => {

  if (!sliderRef.current) return;

  const slider = sliderRef.current;

  const cardWidth =
    slider.firstChild.offsetWidth + 24;

  const index = Math.round(
    slider.scrollLeft / cardWidth
  );

  setActiveDot(index);

}}

        >

          {group.map((image, index) => (

            <div

              key={index}

              style={{
                flex: "0 0 100%",
                scrollSnapAlign: "center",
                transition: "0.35s"
              }}

            >

              <img

                src={image}

                alt=""

                draggable={false}

                style={{

                  width: "100%",

                  height: "360px",

                  objectFit: "cover",

                  borderRadius: "32px",

                  userSelect: "none",

                  pointerEvents: "none",

                  transition: "transform .35s"

                }}

                onMouseEnter={(e) => {

                  e.currentTarget.style.transform = "scale(1.015)";

                }}

                onMouseLeave={(e) => {

                  e.currentTarget.style.transform = "scale(1)";

                }}

              />

            </div>

          ))}

        </div>

            </div>

      {/* Indicadores */}

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
          marginTop: "22px"
        }}
      >

        {group.map((_, index) => (

          <div

            key={index}

            onClick={() => {

              if (!sliderRef.current) return;

              const slider = sliderRef.current;

              const cardWidth =
                slider.firstChild.offsetWidth + 24;

              slider.scrollTo({

                left: cardWidth * index,

                behavior: "smooth"

              });

              setActiveDot(index);

            }}

            style={{

  width: activeDot === index ? "40px" : "10px",

  height: "10px",

  borderRadius: "30px",

  background:
    activeDot === index
      ? "#ffffff"
      : "rgba(255,255,255,.30)",

  transition: "all .6s ease",

  cursor: "pointer",

  transform:
    activeDot === index
      ? "scaleX(1)"
      : "scaleX(1)",

  animation:
    activeDot === index
      ? "pulseBar 2s infinite ease-in-out"
      : "none"

}}

          />

        ))}

      </div>

    </div>

  );

};

export default ImageGridV2;